const ComingSoon = () => {
  return (
    <div className="flex items-center justify-center h-full w-full min-h-[60vh]">
      <p className="text-3xl">
        <span className="text-3xl">Coming Soon</span>
      </p>
    </div>
  );
};

export default ComingSoon;
